import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
const paddingStyles = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8'
};
export function Card({
  children,
  className = '',
  onClick,
  padding = 'md'
}: CardProps) {
  const baseClasses = `bg-white rounded-lg border border-gray-200 shadow-sm ${paddingStyles[padding]}`;
  const clickableClasses = onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : '';
  return <div className={`${baseClasses} ${clickableClasses} ${className}`} onClick={onClick} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined} onKeyDown={onClick ? e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  } : undefined} data-id="element-314">
      {children}
    </div>;
}
interface CardHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}
export function CardHeader({
  title,
  subtitle,
  action
}: CardHeaderProps) {
  return <div className="flex items-start justify-between mb-4" data-id="element-315">
      <div data-id="element-316">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-317">{title}</h3>
        {subtitle && <p className="text-sm text-gray-500 mt-0.5" data-id="element-318">{subtitle}</p>}
      </div>
      {action && <div data-id="element-319">{action}</div>}
    </div>;
}